module.exports = require('./helpers/bundle-url').getBundleURL('73sox') + "logo-dark.eefe0b7f.svg";